
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-copilot-development-services",
      function () {
        return require("private-next-pages/ai-copilot-development-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-copilot-development-services"])
      });
    }
  